import React, { useState } from 'react'

import Layout from 'components/shared/Layout'
import SearchResults from 'components/shared/search/SearchResults'
import { Title, Text } from 'components/typo'
import classnames from 'classnames/bind'
import { ReactComponent as Search } from '../search.svg'
import css from './styles.module.scss'
import { useRegisterStickyBar } from '../../HasStickyBarProvider'

const cx = classnames.bind(css)

const SearchBar = ({ indices }) => {
  const [searching, setSearching] = useState(false)

  useRegisterStickyBar()

  return (
    <div className={cx(css.SearchBar, { searching })}>
      <Layout type="wrapper" className={css.content}>
        <Title tag="h1" size="small" className={css.title}>
          Resource Center
        </Title>
        <div onClick={() => setSearching(true)} className={css.search}>
          <div className={css.left}>
            <Search className={css.icon} />
            <Text size="small">Search for Resources</Text>
          </div>
        </div>
      </Layout>
      {searching && (
        <SearchResults
          className={css.results}
          indices={indices}
          closePopin={() => setSearching(false)}
        />
      )}
    </div>
  )
}

SearchBar.defaultProps = {}

export default SearchBar
